var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 990 720"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E65"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E65",
    className: "cls-2",
    x: 576,
    y: 231,
    width: 70,
    height: 111
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "E66"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E66",
    className: "cls-2",
    x: 649,
    y: 231,
    width: 98,
    height: 111
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "E67"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E67",
    className: "cls-2",
    points: "751 221 849 221 849 231 917 231 917 310 801 310 801 342 751 342 751 221"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "E68"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E68",
    className: "cls-2",
    points: "804 313 917 313 917 405 804 405 804 371 782 371 782 345 804 345 804 313"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "E69"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E69",
    className: "cls-2",
    points: "917 409 917 486 849 486 849 499 751 499 751 374 801 374 801 409 917 409"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "E70"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E70",
    className: "cls-2",
    points: "747 381 747 486 649 486 649 374 723 374 723 381 747 381"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "E71"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E71",
    className: "cls-2",
    points: "646 374 646 486 547 486 547 381 571 381 571 374 646 374"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "E72"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E72",
    className: "cls-2",
    points: "544 381 544 486 446 486 446 374 520 374 520 381 544 381"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "E73"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E73",
    className: "cls-2",
    points: "443 374 443 486 344 486 344 381 368 381 368 374 443 374"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "E74"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E74",
    className: "cls-2",
    points: "341 381 341 486 243 486 243 374 317 374 317 381 341 381"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "E75"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E75",
    className: "cls-2",
    points: "239 374 239 499 141 499 141 486 73 486 73 409 190 409 190 374 239 374"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "E76"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E76",
    className: "cls-2",
    points: "187 313 187 345 207 345 207 371 187 371 187 406 73 406 73 313 187 313"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "E77"
  }, /*#__PURE__*/React.createElement("polygon", {
    "data-id": "E77",
    className: "cls-2",
    points: "73 231 141 231 141 221 239 221 239 342 190 342 190 310 73 310 73 231"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "E78"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E78",
    className: "cls-2",
    x: 242,
    y: 231,
    width: 99,
    height: 111
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "E79"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-id": "E79",
    className: "cls-2",
    x: 344,
    y: 231,
    width: 121,
    height: 111
  }))));
}
export default "data:image/svg+xml;base64,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";
export { SvgP5 as ReactComponent };